import React, { useMemo, useState } from 'react';
import { buildUiHelpers } from './sharedUi';
import { NEWSLETTER_CONSENT_TEXT } from './newsletterConsent';
import PublicNewsletterForm from './PublicNewsletterForm';

export default function AuthSection({
  COLORS,
  inputStyle,
  authMode,
  setAuthMode,
  email,
  setEmail,
  password,
  setPassword,
  loginFehler,
  loginFailureCount,
  loginWaitSeconds,
  loginHelpMsg,
  loginHelpErr,
  loginHelpLoading,
  login,
  setResetEmail,
  requestLoginLink,
  resendVerificationFromLogin,
  loginLinkToken,
  loginLinkMsg,
  loginLinkErr,
  loginLinkSaving,
  confirmLoginLink,
  leaveLoginLink,
  login2faCode,
  setLogin2faCode,
  login2faErr,
  login2faMsg,
  bestaetigeLogin2FA,
  registerEmail,
  setRegisterEmail,
  registerPassword,
  registerNewsletter,
  setRegisterNewsletter,
  setRegisterPassword,
  registerErr,
  registerMsg,
  registerAccount,
  verifyEmail,
  setVerifyEmail,
  verifyCode,
  setVerifyCode,
  verifyErr,
  verifyMsg,
  verifyEmailCode,
  resendVerificationCode,
  verificationLinkToken,
  verificationLinkMsg,
  verificationLinkErr,
  verificationLinkSaving,
  verifyEmailLink,
  leaveEmailVerificationLink,
  resetEmail,
  setResetEmailValue,
  resetCode,
  setResetCode,
  resetPassword,
  setResetPassword,
  resetErr,
  resetMsg,
  requestPasswordReset,
  confirmPasswordReset,
  footer,
}) {
  const { Card, Btn } = useMemo(() => buildUiHelpers({ COLORS, th: {} }), [COLORS]);
  const [showPassword, setShowPassword] = useState(false);
  const [capsLockActive, setCapsLockActive] = useState(false);
  const loginWaitText = loginWaitSeconds > 0
    ? `${String(Math.floor(loginWaitSeconds / 60)).padStart(2, '0')}:${String(loginWaitSeconds % 60).padStart(2, '0')}`
    : '';

  return (
    <div
      style={{
        minHeight: '100vh',
        background: `radial-gradient(1000px 480px at 15% -5%, ${COLORS.bgSoft} 0%, ${COLORS.bg} 45%, #071015 100%)`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '18px',
        padding: '24px',
        fontFamily: "'Manrope', 'Sora', 'Nunito Sans', 'Segoe UI', sans-serif",
        overflowY: 'auto',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '460px',
        }}
      >
        <Card style={{ width: '100%', maxWidth: '460px', flex: '1 1 420px' }}>
          <div style={{ textAlign: 'center', marginBottom: '36px' }}>
            <img
              src="/ET_App_Logo_Schild.png"
              alt="Einfach-Trading.de"
              style={{ height: '76px', width: 'auto', display: 'block', margin: '0 auto 14px' }}
            />
            <h1 style={{ margin: 0, fontSize: '22px', color: COLORS.text }}>Einfach-Trading.de</h1>
          </div>
          {authMode !== 'verifylink' && authMode !== 'loginlink' && authMode !== 'newsletter' && (
            <div style={{ display: 'flex', gap: '8px', marginBottom: '22px' }}>
              {[
                { id: 'login', label: 'Einloggen' },
                { id: 'register', label: 'Registrieren' },
                { id: 'verify', label: 'Code bestätigen' },
              ].map(tab => (
                <button
                  key={tab.id}
                  onClick={() => setAuthMode(tab.id)}
                  style={{
                    flex: 1,
                    border: 'none',
                    borderRadius: '8px',
                    padding: '8px 10px',
                    background: authMode === tab.id ? COLORS.accent : '#ffffff08',
                    color: authMode === tab.id ? '#fff' : COLORS.muted,
                    cursor: 'pointer',
                    fontWeight: '600',
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          )}

          {authMode === 'newsletter' && <PublicNewsletterForm COLORS={COLORS} inputStyle={inputStyle} />}

          {authMode === 'verifylink' && (
            <>
              <h2 style={{ margin: '0 0 10px', color: COLORS.text, fontSize: '18px' }}>
                E-Mail-Adresse bestätigen
              </h2>
              <div style={{ color: COLORS.muted, fontSize: '13px', marginBottom: '18px', lineHeight: 1.6 }}>
                Bestätige deine E-Mail-Adresse mit einem Klick. Erst danach wird dein Account freigeschaltet.
              </div>
              {verificationLinkErr && (
                <div style={{ color: COLORS.red, fontSize: '13px', marginBottom: '12px' }}>
                  ⚠ {verificationLinkErr}
                </div>
              )}
              {verificationLinkMsg && (
                <div style={{ color: COLORS.green, fontSize: '13px', marginBottom: '12px', lineHeight: 1.6 }}>
                  ✓ {verificationLinkMsg}
                </div>
              )}
              {!verificationLinkMsg && (
                <Btn
                  onClick={verifyEmailLink}
                  disabled={verificationLinkSaving || !verificationLinkToken}
                  style={{ width: '100%' }}
                >
                  {verificationLinkSaving ? 'Wird bestätigt…' : 'E-Mail-Adresse bestätigen'}
                </Btn>
              )}
              <button
                onClick={leaveEmailVerificationLink}
                style={{
                  marginTop: '12px',
                  background: 'transparent',
                  border: 'none',
                  color: COLORS.cyan,
                  cursor: 'pointer',
                  fontSize: '13px',
                  padding: 0,
                }}
              >
                Zum Login
              </button>
            </>
          )}

          {authMode === 'loginlink' && (
            <>
              <h2 style={{ margin: '0 0 10px', color: COLORS.text, fontSize: '18px' }}>
                Mit Login-Link anmelden
              </h2>
              <div style={{ color: COLORS.muted, fontSize: '13px', marginBottom: '18px', lineHeight: 1.6 }}>
                Bestätige die Anmeldung auf diesem Gerät. Der Link ist einmalig und zehn Minuten gültig.
              </div>
              {loginLinkErr && (
                <div style={{ color: COLORS.red, fontSize: '13px', marginBottom: '12px' }}>
                  ⚠ {loginLinkErr}
                </div>
              )}
              {loginLinkMsg && (
                <div style={{ color: COLORS.green, fontSize: '13px', marginBottom: '12px' }}>
                  ✓ {loginLinkMsg}
                </div>
              )}
              <Btn
                onClick={confirmLoginLink}
                disabled={loginLinkSaving || !loginLinkToken}
                style={{ width: '100%' }}
              >
                {loginLinkSaving ? 'Anmeldung läuft…' : 'Jetzt anmelden'}
              </Btn>
              <button
                onClick={leaveLoginLink}
                style={{
                  marginTop: '12px',
                  background: 'transparent',
                  border: 'none',
                  color: COLORS.cyan,
                  cursor: 'pointer',
                  fontSize: '13px',
                  padding: 0,
                }}
              >
                Zurück zum Login
              </button>
            </>
          )}

          {authMode === 'login' && (
            <>
              <label style={{ fontSize: '12px', color: COLORS.muted, display: 'block', marginBottom: '6px' }}>E-Mail</label>
              <input
                style={inputStyle}
                type="email"
                autoComplete="email"
                placeholder="user@example.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && login()}
              />
              <label style={{ fontSize: '12px', color: COLORS.muted, display: 'block', marginBottom: '6px' }}>Passwort</label>
              <input
                style={inputStyle}
                type={showPassword ? 'text' : 'password'}
                autoComplete="current-password"
                placeholder="••••••••"
                value={password}
                onChange={e => setPassword(e.target.value)}
                onKeyDown={e => {
                  setCapsLockActive(Boolean(e.getModifierState?.('CapsLock')));
                  if (e.key === 'Enter' && loginWaitSeconds <= 0) login();
                }}
                onKeyUp={e => setCapsLockActive(Boolean(e.getModifierState?.('CapsLock')))}
              />
              <label style={{ display: 'flex', alignItems: 'center', gap: '7px', color: COLORS.muted, fontSize: '12px', margin: '-4px 0 10px' }}>
                <input
                  type="checkbox"
                  checked={showPassword}
                  onChange={e => setShowPassword(e.target.checked)}
                />
                Passwort anzeigen
              </label>
              {capsLockActive && (
                <div style={{ color: COLORS.yellow, fontSize: '12px', marginBottom: '10px' }}>
                  Feststelltaste ist aktiviert.
                </div>
              )}
              {loginFehler && <div style={{ color: COLORS.red, fontSize: '13px', marginBottom: '12px' }}>⚠ {loginFehler}</div>}
              {loginWaitSeconds > 0 && (
                <div style={{ color: COLORS.yellow, fontSize: '13px', marginBottom: '12px' }}>
                  Neuer Login-Versuch in {loginWaitText} Minuten.
                </div>
              )}
              <Btn disabled={loginWaitSeconds > 0} onClick={login} style={{ width: '100%' }}>
                {loginWaitSeconds > 0 ? `Gesperrt · ${loginWaitText}` : 'Einloggen'}
              </Btn>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px 18px', marginTop: '12px' }}>
                <button
                  onClick={() => {
                    setResetEmail(email.trim());
                    setAuthMode('forgot');
                  }}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    color: COLORS.cyan,
                    cursor: 'pointer',
                    fontSize: '13px',
                    padding: 0,
                  }}
                >
                  Passwort vergessen?
                </button>
                <button
                  onClick={requestLoginLink}
                  disabled={loginHelpLoading === 'login-link'}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    color: COLORS.cyan,
                    cursor: 'pointer',
                    fontSize: '13px',
                    padding: 0,
                  }}
                >
                  {loginHelpLoading === 'login-link' ? 'Wird gesendet…' : 'Login-Link per E-Mail'}
                </button>
              </div>
              {(loginFailureCount >= 2 || loginWaitSeconds > 0) && (
                <div style={{ marginTop: '18px', paddingTop: '14px', borderTop: `1px solid ${COLORS.border}` }}>
                  <div style={{ color: COLORS.text, fontWeight: '700', fontSize: '13px', marginBottom: '6px' }}>
                    Anmeldung klappt nicht?
                  </div>
                  <div style={{ color: COLORS.muted, fontSize: '12px', lineHeight: 1.6, marginBottom: '10px' }}>
                    Prüfe die Schreibweise deiner E-Mail und die Feststelltaste. Du kannst dein Passwort zurücksetzen oder eine offene E-Mail-Bestätigung erneut anfordern.
                  </div>
                  <button
                    onClick={resendVerificationFromLogin}
                    disabled={loginHelpLoading === 'verification'}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      color: COLORS.cyan,
                      cursor: 'pointer',
                      fontSize: '13px',
                      padding: 0,
                    }}
                  >
                    {loginHelpLoading === 'verification' ? 'Wird gesendet…' : 'Bestätigungsmail erneut senden'}
                  </button>
                </div>
              )}
              {loginHelpErr && <div style={{ color: COLORS.red, fontSize: '13px', marginTop: '12px' }}>⚠ {loginHelpErr}</div>}
              {loginHelpMsg && <div style={{ color: COLORS.green, fontSize: '13px', marginTop: '12px', lineHeight: 1.5 }}>✓ {loginHelpMsg}</div>}
            </>
          )}

          {authMode === 'login2fa' && (
            <>
              <div style={{ color: COLORS.muted, fontSize: '13px', marginBottom: '12px', lineHeight: 1.6 }}>
                Gib den 6-stelligen 2FA-Code aus deiner E-Mail ein, um die Anmeldung abzuschließen.
              </div>
              <label style={{ fontSize: '12px', color: COLORS.muted, display: 'block', marginBottom: '6px' }}>2FA-Code</label>
              <input
                style={inputStyle}
                type="text"
                autoComplete="one-time-code"
                placeholder="6-stelliger Code"
                value={login2faCode}
                onChange={e => setLogin2faCode(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && bestaetigeLogin2FA()}
              />
              {login2faErr && <div style={{ color: COLORS.red, fontSize: '13px', marginBottom: '12px' }}>⚠ {login2faErr}</div>}
              {login2faMsg && <div style={{ color: COLORS.green, fontSize: '13px', marginBottom: '12px' }}>✓ {login2faMsg}</div>}
              <Btn onClick={bestaetigeLogin2FA} style={{ width: '100%' }}>2FA-Code bestätigen</Btn>
              <button
                onClick={() => {
                  setAuthMode('login');
                }}
                style={{
                  marginTop: '12px',
                  background: 'transparent',
                  border: 'none',
                  color: COLORS.cyan,
                  cursor: 'pointer',
                  fontSize: '13px',
                  padding: 0,
                }}
              >
                Zurück zum Login
              </button>
            </>
          )}

          {authMode === 'register' && (
            <>
              <label style={{ fontSize: '12px', color: COLORS.muted, display: 'block', marginBottom: '6px' }}>E-Mail-Adresse</label>
              <input
                style={inputStyle}
                type="email"
                autoComplete="email"
                placeholder="user@example.com"
                value={registerEmail}
                onChange={e => setRegisterEmail(e.target.value)}
              />
              <label style={{ fontSize: '12px', color: COLORS.muted, display: 'block', marginBottom: '6px' }}>Passwort</label>
              <input
                style={inputStyle}
                type="password"
                autoComplete="new-password"
                placeholder="mindestens 10 Zeichen, Groß/Klein/Zahl"
                value={registerPassword}
                onChange={e => setRegisterPassword(e.target.value)}
              />
              <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, lineHeight: 1.5, marginBottom: 12, color: COLORS.text }}>
                <input type="checkbox" checked={registerNewsletter} onChange={e => setRegisterNewsletter(e.target.checked)} />
                <span>{NEWSLETTER_CONSENT_TEXT} (Optional) <a href="https://www.einfach-trading.de/rechtliches.html" target="_blank" rel="noreferrer" style={{ color: COLORS.cyan }}>Datenschutz</a></span>
              </label>
              {registerErr && <div style={{ color: COLORS.red, fontSize: '13px', marginBottom: '12px' }}>⚠ {registerErr}</div>}
              {registerMsg && <div style={{ color: COLORS.green, fontSize: '13px', marginBottom: '12px' }}>✓ {registerMsg}</div>}
              <Btn onClick={registerAccount} style={{ width: '100%' }}>Registrieren</Btn>
            </>
          )}

          {authMode === 'verify' && (
            <>
              <div style={{ color: COLORS.muted, fontSize: '13px', marginBottom: '12px', lineHeight: 1.6 }}>
                Gib hier den 6-stelligen Code aus deiner Verifizierungs-E-Mail ein.
              </div>
              <label style={{ fontSize: '12px', color: COLORS.muted, display: 'block', marginBottom: '6px' }}>E-Mail-Adresse</label>
              <input
                style={inputStyle}
                type="email"
                autoComplete="email"
                placeholder="user@example.com"
                value={verifyEmail}
                onChange={e => setVerifyEmail(e.target.value)}
              />
              <label style={{ fontSize: '12px', color: COLORS.muted, display: 'block', marginBottom: '6px' }}>Verifizierungscode</label>
              <input
                style={inputStyle}
                type="text"
                autoComplete="one-time-code"
                placeholder="6-stelliger Code"
                value={verifyCode}
                onChange={e => setVerifyCode(e.target.value)}
              />
              {verifyErr && <div style={{ color: COLORS.red, fontSize: '13px', marginBottom: '12px' }}>⚠ {verifyErr}</div>}
              {verifyMsg && <div style={{ color: COLORS.green, fontSize: '13px', marginBottom: '12px' }}>✓ {verifyMsg}</div>}
              <div style={{ display: 'flex', gap: '10px' }}>
                <Btn onClick={verifyEmailCode} style={{ flex: 1 }}>Code bestätigen</Btn>
                <Btn onClick={resendVerificationCode} color="ghost" style={{ flex: 1 }}>Code neu senden</Btn>
              </div>
            </>
          )}

          {authMode === 'forgot' && (
            <>
              <div style={{ color: COLORS.muted, fontSize: '13px', marginBottom: '12px', lineHeight: 1.6 }}>
                Fordere zuerst einen Reset-Code per E-Mail an und trage danach den Code zusammen mit deinem neuen Passwort ein.
              </div>
              <label style={{ fontSize: '12px', color: COLORS.muted, display: 'block', marginBottom: '6px' }}>E-Mail-Adresse</label>
              <input
                style={inputStyle}
                type="email"
                autoComplete="email"
                placeholder="user@example.com"
                value={resetEmail}
                onChange={e => setResetEmailValue(e.target.value)}
              />
              <label style={{ fontSize: '12px', color: COLORS.muted, display: 'block', marginBottom: '6px' }}>Reset-Code</label>
              <input
                style={inputStyle}
                type="text"
                autoComplete="one-time-code"
                placeholder="6-stelliger Code aus der E-Mail"
                value={resetCode}
                onChange={e => setResetCode(e.target.value)}
              />
              <label style={{ fontSize: '12px', color: COLORS.muted, display: 'block', marginBottom: '6px' }}>Neues Passwort</label>
              <input
                style={inputStyle}
                type="password"
                autoComplete="new-password"
                placeholder="mindestens 10 Zeichen, Groß/Klein/Zahl"
                value={resetPassword}
                onChange={e => setResetPassword(e.target.value)}
              />
              {resetErr && <div style={{ color: COLORS.red, fontSize: '13px', marginBottom: '12px' }}>⚠ {resetErr}</div>}
              {resetMsg && <div style={{ color: COLORS.green, fontSize: '13px', marginBottom: '12px' }}>✓ {resetMsg}</div>}
              <div style={{ display: 'flex', gap: '10px' }}>
                <Btn onClick={requestPasswordReset} color="ghost" style={{ flex: 1 }}>Code anfordern</Btn>
                <Btn onClick={confirmPasswordReset} style={{ flex: 1 }}>Passwort zurücksetzen</Btn>
              </div>
              <button
                onClick={() => {
                  setVerifyEmail(resetEmail.trim());
                  setAuthMode('verify');
                }}
                style={{
                  marginTop: '12px',
                  background: 'transparent',
                  border: 'none',
                  color: COLORS.cyan,
                  cursor: 'pointer',
                  fontSize: '13px',
                  padding: 0,
                }}
              >
                Stattdessen Verifizierungs-Code eingeben
              </button>
            </>
          )}
        </Card>
      </div>
      {footer}
    </div>
  );
}
